module.exports = __webpack_public_path__ + "img/aseguradora_tajy.43c10b92.png";